import { Select, Tabs } from "antd/lib";
import CandlestickPatterns from "@/app/components/products/ProductSignals/Details/Candlestick";
import { useTranslations } from "next-intl";
import { useState } from "react";
import TechnicalAnalysis from "@/app/components/products/ProductSignals/Details/TechnicalAnalysis";
import useAxiosQuery from "@/hooks/useMyQuery";
import { SelectsDurationSignal } from "@/constant";

// Other interfaces (IStatistics, IPivot, etc.) here

export enum KeyStatistics {
  "Buy" = "Buy",
  "Neutral" = "Neutral",
  "Sell" = "Sell",
}

export interface IPivot {
  name: string;
  value: {
    p: number;
    s3: number;
    s2: number;
    s1: number;
    r1: number;
    r2: number;
    r3: number;
  };
}

export interface IMovingAverageSummary {
  name_ma: string;
  value_simple: number;
  value_exponential: number;
  action_simple: number;
  action_exponential: number;
}

export interface IOscillatorsSummary {
  name: string;
  value: number;
  action: number;
}

export type IStatistics = {
  [key in keyof typeof KeyStatistics]: number;
};
export interface ITextSummary {
  name: string;
  text: string[];
}

export interface ISignalDetails {
  statistics: IStatistics;
  text_summary: ITextSummary[];
  details: {
    symbol: string;
    moving_average_data: IMovingAverageSummary[];
    oscillators_summary: IOscillatorsSummary[];
    pivot_data: IPivot[];
    score: number;
    stored_time: string;
    expired_time: string;
    created_at: string;
    id: string;
  };
  status: string;
  value: number;
}

export default function SignalDetails({ symbol }: { symbol: string }) {
  const t = useTranslations("products");
  const [tab, switchTab] = useState("holders_distribution");
  const [duration, setDuration] = useState<string>("1D");

  // Fetch signal details based on symbol and selected duration
  const { data: response, isLoading } = useAxiosQuery<{ data?: ISignalDetails }>(
    {
      url: "v1/product/signal/signal-details",
      params: { symbol, duration },
    },
    {
      queryKey: ["v1/product/signal/signal-details", symbol, duration],
    },
  );

  // Handle duration change
  const handleDurationChange = (value: string) => {
    setDuration(value);
  };

  return (
    <Tabs
      tabBarExtraContent={
        <Select value={duration} onChange={handleDurationChange} style={{ width: 120 }}>
          {SelectsDurationSignal.map(({ label }) => (
            <Select.Option key={label} value={label}>
              {label}
            </Select.Option>
          ))}
        </Select>
      }
      activeKey={tab}
      onChange={switchTab}
      defaultActiveKey={"holders_distribution"}
      items={[
        {
          label: t("Technical_Analysis"),
          key: "holders_distribution",
          children: <TechnicalAnalysis data={response?.data} duration={duration} symbol={symbol} loading={isLoading} />,
        },
        {
          label: t("Candlestick_Patterns"),
          key: "top_holders",
          children: <CandlestickPatterns symbol={symbol} />,
        },
      ]}
    />
  );
}
